import { render, staticRenderFns } from "./AsEmployeeNewPage.vue?vue&type=template&id=1ea33cf0&scoped=true"
import script from "./AsEmployeeNewPage.vue?vue&type=script&lang=js"
export * from "./AsEmployeeNewPage.vue?vue&type=script&lang=js"
import style0 from "./AsEmployeeNewPage.vue?vue&type=style&index=0&id=1ea33cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea33cf0",
  null
  
)

export default component.exports